import React from "react";
import { Box, List, Typography, Divider } from "@mui/material";
import SidebarItem from "./SidebarItem";

import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonIcon from "@mui/icons-material/Person";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import LogoutIcon from "@mui/icons-material/Logout";
import PaidIcon from "@mui/icons-material/Paid";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import BoltIcon from "@mui/icons-material/Bolt";
import GppGoodIcon from "@mui/icons-material/GppGood";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

import { SidebarProps, SidebarItemType } from "../../types/interface";
import { APP_STRINGS, MENU_STRINGS } from "../../constants/strings";
import { COLORS } from "../../theme/colors";

const Sidebar: React.FC<SidebarProps> = ({ collapsed }) => {
  const mainMenu: SidebarItemType[] = [
    { label: MENU_STRINGS.DASHBOARD, path: "/dashboard", icon: DashboardIcon },
  ];

  const managementMenu: SidebarItemType[] = [
    { label: MENU_STRINGS.LEADS, path: "/leads", icon: PersonIcon },
    {
      label: MENU_STRINGS.CREDIT,
      path: "/credit",
      icon: GppGoodIcon,
    },
    { label: MENU_STRINGS.BANK_DISBURSEMENT, path: "/loans", icon: AccountBalanceIcon },
    {
      label: "Disbursement",
      path: "/disbursement",
      icon: CurrencyRupeeIcon,
    },
    { label: MENU_STRINGS.COMMISSION, path: "/commission", icon: PaidIcon },
    {
      label: "Notifications", 
      path: "/notifications",
      icon: NotificationsNoneIcon,
    },
  ];

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  return (
    <Box
      sx={{
        width: collapsed ? 70 : 230,
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: COLORS.sidebarBg,
        borderRight: `1px solid ${COLORS.border}`,
      }}
    >
      {/* 🔥 TOP LOGO */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          p: 2,
        }}
      >
        <BoltIcon sx={{ color: COLORS.primary }} />

        {!collapsed && (
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: 700,
              color: COLORS.primary,
            }}
          >
            {APP_STRINGS.APP_NAME}
          </Typography>
        )}
      </Box>

      <Divider />

      {/* 🔥 MIDDLE */}
      <Box sx={{ flex: 1, overflowY: "auto" }}>
        {/* MAIN LABEL */}
        {!collapsed && (
          <Typography
            sx={{
              px: 2,
              mt: 1,
              mb: 1,
              fontSize: 11,
              letterSpacing: "0.5px",
              color: "#94a3b8",
              textTransform: "uppercase",
              fontWeight: 600,
            }}
          >
            Main
          </Typography>
        )}

        <List>
          {mainMenu.map((item) => (
            <SidebarItem key={item.path} {...item} collapsed={collapsed} />
          ))}
        </List>

        {/* MANAGEMENT LABEL */}
        {!collapsed && (
          <Typography
            sx={{
              px: 2,
              mt: 2,
              mb: 1,
              fontSize: 11,
              letterSpacing: "0.5px",
              color: "#94a3b8",
              textTransform: "uppercase",
              fontWeight: 600,
            }}
          >
            Management
          </Typography>
        )}

        <List>
          {managementMenu.map((item) => (
            <SidebarItem key={item.path} {...item} collapsed={collapsed} />
          ))}
        </List>
      </Box>

      {/* 🔥 BOTTOM LOGOUT */}
      <Box sx={{ p: 1 }}>
        <Divider sx={{ mb: 1 }} />

        <SidebarItem
          label={MENU_STRINGS.LOGOUT}
          icon={LogoutIcon}
          collapsed={collapsed}
          onClick={handleLogout}
        />
      </Box>
    </Box>
  );
};

export default Sidebar;
